document.addEventListener("DOMContentLoaded", function() {
    const buttons = document.querySelectorAll('.custom_tabs__button');
    const panels = document.querySelectorAll('.custom_tabs__panel');

    // Nothing to do if this page has no tabs section
    if (buttons.length === 0 || panels.length === 0) return;

    // Function to hide all panels and remove active class from buttons
    function hideAllPanels() {
        panels.forEach(panel => {
            panel.style.display = 'none'; // Hide all panels
        });
        buttons.forEach(button => {
            button.classList.remove('active'); // Remove active class from all buttons
        });
    }

    // Show the selected panel and activate the button
    function showPanel(panelId) {
        hideAllPanels(); // Hide all panels first
        const panel = document.getElementById(panelId);
        if (panel) {
            panel.style.display = 'block'; // Show the selected panel, if it exists
        }
        const activeButton = Array.from(buttons).find(button => button.dataset.target === panelId);
        if (activeButton) {
            activeButton.classList.add('active'); // Add active class to the clicked button
        }
    }

    // Add click event to each button
    buttons.forEach(button => {
        button.addEventListener('click', function() {
            showPanel(this.dataset.target); // Show the panel based on data-target
        });
    });

    // Show the first tab's content by default
    showPanel('dna-content'); // Change this to whichever content you want to display initially
});